import { call, put, takeEvery } from "redux-saga/effects";

import * as types from "./changePasswordActionType";
import * as actions from "./changePasswordActions";
import * as changePasswordServices from "./changePasswordServices";
import SweetAlert from "../../../components/sweetalert/SweetAlert";

function* changePasswordSaga(action) {
  try {
    const response = yield call(changePasswordServices.changePassword, action.payload);
    if (response?.success) {
      yield put(actions.changePasswordSuccess(response));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Password changed successfully",
      });
    } else {
      const errorMessage = response?.errorMessage || "Failed to change password";
      yield put(actions.changePasswordFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.errorMessage || "Failed to change password";
    yield put(actions.changePasswordFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

export default function* watchChangePasswordSaga() {
  yield takeEvery(types.CHANGE_PASSWORD_REQUEST, changePasswordSaga);
}
